export const DEFAULT_BLOCKING_FUNCTION_ERRORS = [
	"auth/error-code:-47",
	"auth/the-service-is-currently-unavailable",
	"auth/internal-error",
	"auth/internal-error-encountered",
	"general/error",
];

export const DEFAULT_AUTH_RETRY_DELAYS_MS = [350, 900];
